export default "__VITE_PUBLIC_ASSET__eae7a68b__"